module.exports = __webpack_public_path__ + "2-es2015.worker.js"